const debounce = function (func, timeout = 300) {
    let timer;
    return (...args) => {
        clearTimeout(timer);
        timer = setTimeout(() => { func.apply(this, args); }, timeout);
    };
};
const setMenuLocations = debounce(function () {
	var $winWidth = $(window).width();
	if ($winWidth >= 992) {
		if (!$('#site-nav-container #shopify-section-primary-menu').length) {
			$('#shopify-section-primary-menu').detach().appendTo('#site-nav-container');
			$('#shopify-section-secondary-menu').detach().prependTo('#site-utilities');
		}
		return;
	}
	if (!$('#site-menu-panel #shopify-section-primary-menu').length) {
		$('#shopify-section-primary-menu').detach().appendTo('#site-menu-panel');
		$('#shopify-section-secondary-menu').detach().appendTo('#site-menu-panel'); 
	}
}, 200);

setMenuLocations();
window.addEventListener("resize", setMenuLocations);